import { toggle } from 'cerebral/operators'

export default [toggle('state:login.acceptedGDPR')]



// WEBPACK FOOTER //
// ./src/modules/login/chains/toggleAcceptGDPR.js